import type { AxiosRequestConfig } from 'axios';
import {
  ApiToken,
  ApiTokenCreated,
  CreateApiTokenRequest,
} from '../interfaces/ApiToken';
import Client from './client';

/**
 * Sellers must send their admin-issued API access password (second password)
 * on every token-management call; admins do not need it.
 */
export const API_ACCESS_PASSWORD_HEADER = 'x-api-access-password';

const withApiAccessPassword = (
  password?: string
): AxiosRequestConfig | undefined =>
  password ? { headers: { [API_ACCESS_PASSWORD_HEADER]: password } } : undefined;

class ApiTokenApi {
  private static classInstance?: ApiTokenApi;

  public static get instance() {
    if (!this.classInstance) {
      this.classInstance = new ApiTokenApi();
    }
    return this.classInstance;
  }

  public listTokens = (apiAccessPassword?: string): Promise<ApiToken[]> => {
    return Client.get(`/api-token`, withApiAccessPassword(apiAccessPassword));
  };

  public createToken = (
    body: CreateApiTokenRequest = {},
    apiAccessPassword?: string
  ): Promise<ApiTokenCreated> => {
    return Client.post(
      `/api-token`,
      body,
      withApiAccessPassword(apiAccessPassword)
    );
  };

  public rotateToken = (
    id: string,
    apiAccessPassword?: string
  ): Promise<ApiTokenCreated> => {
    return Client.post(
      `/api-token/${id}/rotate`,
      undefined,
      withApiAccessPassword(apiAccessPassword)
    );
  };

  public revokeToken = (
    id: string,
    apiAccessPassword?: string
  ): Promise<{ success: true }> => {
    return Client.delete(
      `/api-token/${id}`,
      withApiAccessPassword(apiAccessPassword)
    );
  };
}

export default ApiTokenApi.instance;
